<template>
  <el-table-column :label="label" :prop="prop" class-name="street_address" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '住所'
    },
    prop: {
      type: String,
      default: 'street_address'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.street_address {
      width: 15em;
    }
  }
}
</style>
